/**
 * Configuração centralizada de identificação societária, contato do Encarregado (DPO)
 * e parâmetros legais do CRM.
 *
 * IMPORTANTE: Preencha todos os placeholders {{ASSIM}} antes de publicar em produção
 * e submeta os textos marcados com [REVISAR COM ADVOGADO] à validação jurídica.
 */

declare const __LEGAL_LAST_UPDATED__: string | undefined;

/**
 * Quando `VITE_LEGAL_DRAFT=true` (ex.: em `.env.development`), exibe os avisos de
 * governança e as notas de revisão jurídica (`[REVISAR COM ADVOGADO]`) no fim das seções.
 * Em produção, basta omitir ou definir `VITE_LEGAL_DRAFT=false` para ocultá-los sem editar o texto.
 */
export const IS_LEGAL_DRAFT: boolean =
  import.meta.env.VITE_LEGAL_DRAFT === "true";

/**
 * Data da última modificação de `LegalPages.tsx` / `legalConfig.ts`,
 * injetada automaticamente pelo `vite.config.ts` no build/dev.
 */
const AUTO_LEGAL_UPDATED_AT: string =
  typeof __LEGAL_LAST_UPDATED__ !== "undefined"
    ? __LEGAL_LAST_UPDATED__
    : "03/11/2026";

export const LEGAL_COMPANY_INFO = {
  razaoSocial: "Dotus Group Marketing e Consultoria LTDA",
  nomeFantasia: "Dotus Group Marketing e Consultoria LTDA",
  cnpj: "45.694.719/0001-08",
  enderecoCompleto:
    "Rua Tiradentes, 220 – Quadra 15, Lote 03 – Pico do Amor – Cuiabá/MT",
  emailDpo: "Tecnologia@grupodotus.com.br",
  nomeDpo: "Tecnologia Grupo Dotus",
  emailSuporte: "Tecnologia@grupodotus.com.br",
  telefoneContato: "+55 51 9915-6561",
  foroComarca: "Cuiabá/MT",
  prazoRespostaTitular: "10 (dez) dias úteis",
  prazoRetencaoGravacoes: "30 (trinta) dias",
  prazoRetencaoTransricoesNotas: "365 (trezentos e sessenta e cinco) dias",
  prazoRetencaoLeadsInativos: "730 (setecentos e trinta) dias",
  prazoExportacaoAposCancelamento: "7 (sete) dias",
  versaoPoliticaPrivacidade: "1.0.0",
  versaoTermosUso: "1.0.0",
  versaoPoliticaCookies: "1.0.0",
  dataUltimaAtualizacao: AUTO_LEGAL_UPDATED_AT,
};

export const LEGAL_VERSIONS = {
  privacyPolicyVersion: LEGAL_COMPANY_INFO.versaoPoliticaPrivacidade,
  termsOfUseVersion: LEGAL_COMPANY_INFO.versaoTermosUso,
  cookiePolicyVersion: LEGAL_COMPANY_INFO.versaoPoliticaCookies,
};

export const COMPANY_LEGAL_CONFIG = {
  razaoSocial: LEGAL_COMPANY_INFO.razaoSocial,
  cnpj: LEGAL_COMPANY_INFO.cnpj,
  endereco: LEGAL_COMPANY_INFO.enderecoCompleto,
  dpoEmail: LEGAL_COMPANY_INFO.emailDpo,
  dpoName: LEGAL_COMPANY_INFO.nomeDpo,
  supportEmail: LEGAL_COMPANY_INFO.emailSuporte,
};
